export default __webpack_public_path__ + "static/media/timenrn.bc3b9444.ttf";